import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-650d82b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "develop-progress" }
const _hoisted_2 = {
  "data-test": "develop-review-scores",
  class: "review-scores"
}
const _hoisted_3 = ["data-test"]
const _hoisted_4 = { class: "review-score-name" }
const _hoisted_5 = { class: "review-score-number" }

import { computed } from "vue";
import { DevelopProgressApiModel } from "../api-models";
import PieChart from "./pie-chart.vue";

export interface SelfReviewScore {
  name: string;
  scoreOutOf60: number | null | undefined;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'develop-progress',
  props: {
    model: {}
  },
  setup(__props: any) {

const props = __props;

const scores = computed((): SelfReviewScore[] => {
  const { model } = props;
  return [
    {
      name: "Day 1",
      scoreOutOf60: model.currentStrengthProgress.week1Score,
    },
    {
      name: "Day 11",
      scoreOutOf60: model.currentStrengthProgress.week3Score,
    },
    {
      name: "Day 21",
      scoreOutOf60: model.currentStrengthProgress.week5Score,
    },

    // We no-longer show the follow-up score.
    //  { name: "Day 31", scoreOutOf60: model.currentStrengthProgress.followUpScore }
  ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scores.value, (score, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: score.name,
          class: _normalizeClass(["review-score", { completed: !!score.scoreOutOf60 }]),
          "data-test": `develop-score-${index}`
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(score.name), 1),
          _createVNode(PieChart, {
            size: 50,
            percent: (100 * score.scoreOutOf60) / 60
          }, null, 8, ["percent"]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(score.scoreOutOf60 || "?") + " / 60", 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})